<template>
  <div class="card-with-thumbnail">
    <div class="card-with-thumbnail__header">
      <DataTypeBadge
        v-model="card.dataType"
      />

      <span
        v-tooltip="card.props.title"
        class="card-with-thumbnail__title"
      >
        {{ card.props.title }}
      </span>
    </div>

    <div class="card-with-thumbnail__image">
      <img
        :src="getImgSource(card.componentType)"
        width="144"
        height="112"
      >
    </div>

    <div class="card-with-thumbnail__description">
      {{ card.props.description }}
    </div>

    <div class="card-with-thumbnail__action">
      <DsButton
        color="secondary"
        :loading="isSaving"
        :disabled="isSaving"
        @click="addChart()"
      >
        {{ $t('components.config.ConfigCharts.label.button.addChart') }}
      </DsButton>
    </div>
  </div>
</template>

<script>
import DataTypeBadge from '@/components/DataTypeBadge';
import { DsButton } from '@ds/components';

export default {
  name: 'CardWithThumbnail',
  components: {
    DataTypeBadge,
    DsButton,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
    isSaving: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    getImgSource(componentType) {
      const source = this.$vuetify.theme.dark ? `${componentType}_dark` : `${componentType}_light`;

      return require(`../../../assets/img/thumbnail/${source}.png`);
    },
    addChart() {
      this.$emit('openHiddenCardsModal', this.card);
    },
  },
};
</script>

<style lang="scss" scoped>
  .card-with-thumbnail {
    display: grid;
    justify-content: left;
    width: 360px;
    height: 100%;
    margin: var(--ds-spacing-inset-xs);
    padding: var(--ds-spacing-inset-xs);
    background-color: var(--ds-color-neutral);
    border: 1px solid var(--ds-color-gray-3);
    border-radius: var(--ds-border-radius-md);

    &__header {
      display: flex;
      width: 320px;
      justify-content: stretch;
      align-items: flex-start;
    }

    &__title {
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-baseline);
      line-height: var(--ds-font-line-height-dense);
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    &__image {
      width: 320px;
      margin: var(--ds-spacing-inline-sm) 0;
      text-align: center;
    }

    &__description {
      width: 320px;
      height: 100px;
      font-size: var(--ds-font-size-sm);
      line-height: var(--ds-font-line-height-tight);
      margin-bottom: var(--ds-spacing-inline-xs);
      font-weight: var(--ds-font-weight-regular);
      text-overflow: ellipsis;
      overflow: auto;
    }

    &__action {
      width: 320px;
      text-align: center;
    }
  }
</style>
